//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v10.9.0.0 (Newtonsoft.Json v13.0.0.0) (http://NJsonSchema.org)
// </auto-generated>
//----------------------







export enum OrganizationSubscriptionStatuses {
    Active = 1,
    Canceled = 2,
    ToBeCanceled = 3,
}
